export const APP_NAME = 'FIODECOBRE';
export const APP_VERSION = '0.1.0';

export * from './format/moeda';
export * from './format/data';
export * from './format/documento';
export * from './format/telefone';
export * from './format/quantidade';
export * from './format/fornecedor';
export * from './format/slug';
export * from './format/plural';
export * from './whatsapp/jid';
export * from './whatsapp/pix-fluxo-nativo';
export * from './print/autorizacao';
export * from './print/recibo-troca';
export * from './print/comprovante-pix';
export * from './print/recibo-estorno-pix';
export * from './print/extrato-consignacao';
export * from './tema/cores';
export * from './tema/label-cores';
export * from './constantes';
export * from './identificacao-pedido';
export * from './linha-digitavel';
export * from './boleto-referencia';
export * from './caixa';
export * from './prateleira-obrigatoria';
export * from './desconto';
export * from './preco-cartao';
export * from './monitor-precos';
export * from './margem-meta';
export * from './programa-prestador';
export * from './divergencia-recebimento';
export * from './custo-real-nota';
export * from './apagar-mensagem';
export * from './agenda-aviso';
export * from './agenda-estado';
export * from './marca-loja';
export * from './nome-cliente';
export * from './quem-responde-conversa';
export * from './perna-preco';
export * from './perna-da-nota';
export * from './baixa-parcial';
export * from './ncm';
export * from './ean';
export * from './fly-quantidade';
export * from './fly-variaveis';
export * from './campanha-sem-etiqueta';
export * from './treinamento-questionario';
export * from './ordem-natural';
export * from './cartao-contato';
export * from './rateio-acrescimo';
export * from './quantidade-com-embalagem';
export * from './cfop-bonificacao';
